import React from 'react';
import { Button, Input, Modal, Select } from 'semantic-ui-react';
import Swal from 'sweetalert2';
import membersForms from '../../../services/api/membersForms';
import weddingRequestService from '../../../services/api/weddingRequestService';
import { searchSelectProps } from 'src/components/helpers';

const NewWeddingRequestFacilitator = (props) => {
  const { setOpen, getInfo } = props;
  const [guest, set_guest] = React.useState({});
  const [loading, set_loading] = React.useState(false);

  function getAMember(identification) {
    set_loading(true);
    membersForms
      .getAMember({ identification })
      .then((response) => {
        if (response.data.success) {
          set_loading(false);
          if (response.data.finded && response.data.match) {
            set_guest(response.data.guest);
          }
        }
      })
      .catch((error) => {
        set_loading(false);
        if (error.response) Swal.fire(error.response.data.message);
      });
  }

  function createFacilitator() {
    set_loading(true);
    weddingRequestService
      .createWeddingFacilitator({ guest_id: guest?.id, role: guest?.role })
      .then((response) => {
        if (response.data.success) {
          set_loading(false);
          getInfo();
          setOpen(false);
        }
      })
      .catch((error) => {
        set_loading(false);
        if (error.response) Swal.fire(error.response.data.message);
      });
  }

  return (
    <Modal onClose={() => setOpen(false)} open>
      <Modal.Header>Pastores y facilitadores de matrimonio</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>Crear nuevo pastor o facilitador</p>
          <p>Escribe la cédula para consultar sus datos</p>
          <Input
            type="text"
            placeholder="Cédula"
            onChange={(e) => {
              set_guest({ ...guest, identification: e.target.value });
            }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                getAMember(guest?.identification);
              }
            }}
            value={guest?.identification}
          />
          <Button
            primary
            loading={loading}
            onClick={() => {
              getAMember(guest?.identification);
            }}
          >
            Consultar
          </Button>
          {guest?.name && (
            <div>
              <p>
                <strong>Nombre:</strong> {guest?.name} {guest?.lastName}
                <br />
                <strong>Teléfono:</strong> {guest?.phone}
              </p>
              <Select
                placeholder="Seleccionar rol"
                {...searchSelectProps({
                  value: guest?.role,
                  handler: (e, { value }) => {
                    set_guest({ ...guest, role: value });
                  },
                  options: [
                    { key: 'pastor', text: 'Pastor', value: 'pastor' },
                    { key: 'facilitator', text: 'Facilitador', value: 'facilitator' },
                  ],
                })}
              />
            </div>
          )}
          <div>
            {!!guest?.name && !!guest?.role && (
              <Button primary loading={loading} onClick={createFacilitator}>
                Crear {guest?.role}
              </Button>
            )}
          </div>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button disabled={loading} loading={loading} onClick={() => setOpen(false)}>
          Cerrar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default NewWeddingRequestFacilitator;
